import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Icon } from '@elparking/components'
import { IconBlock } from './ui/ServiceIconLayout'
class ServiceIcon extends React.Component {
    static propTypes = {
        serviceName: PropTypes.string,
        serviceSlug: PropTypes.string,
    }

    getIconName () {
        const {serviceSlug} = this.props
        switch (serviceSlug) {
            case '24-hours':
                return '24h'
            case 'cctv':
                return 'video-camera'
            case 'elevator':
                return 'lift'
            case 'toilets':
                return 'wc'
            case 'key-delivery':
                return 'key'
            case 'handicapped':
                return 'disabled-sign'
            case 'showers':
                return 'showers'
            case 'security24_7':
                return 'security'
            case 'restaurant':
                return 'restaurant'
            case 'car-charge-point':
                return 'service-electric-charge'
            case 'fuel_station':
                return 'gas-station'
            case 'fences':
                return 'fences'
            case 'shop':
                return 'shop'
            case 'washing-machine':
                return 'laundry'
            case 'refrigerated-truck':
                return 'fridge'
            case 'dangerous-goods':
                return 'adr'
            case 'lighting-projectors':
                return 'spotlights'
            default:
                return serviceSlug
        }
    }

    render () {
        const {serviceName} = this.props

        return (
            <IconBlock mr='8px' pr='2px' width='20px' color='gray'>
                <Flex flexDirection='column'>
                    <Icon size='xLarge' color='gray' type={this.getIconName()} title={serviceName} />
                </Flex>
            </IconBlock>
        )
    }
}

export default ServiceIcon
